import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
import _imports_0 from '../../../../public/img/ajax-loader.gif';
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "table"
};
const _hoisted_3 = {
  src: _imports_0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "flex"
};
const _hoisted_6 = {
  class: "pr-2"
};
import { reactive, onMounted } from "vue";
import FirmCreate from "./FirmCreate.vue";
import axios from "axios";
import MainHeader from "@/components/MainHeader.vue";
import { useMeStore } from "@/services/UserService/useMeStore";
import { useAccountsStore } from "@/services/UserService/useAccountsStore";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import QboIcon from "@/components/QboIcon.vue";
import AccountSwitcherService from "@/services/accountSwitcherService";
export default {
  __name: 'FirmLists',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    http: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const meStore = useMeStore();
    const accountsStore = useAccountsStore();
    meStore.alerts = props.alerts;
    accountsStore.alerts = props.alerts;
    let listsState = reactive({
      me: {},
      accepting: false,
      showCreateCompanyModal: false
    });
    onMounted(async () => {
      fetchMe();
    });
    async function fetchMe() {
      listsState.me = await meStore.getMe();
      listsState.me.accounts = await accountsStore.listMyAccounts(true);
    }
    function login(company) {
      const redirect = `${window.location.origin}${window.location.pathname}#/`;
      const accountSwitcherService = new AccountSwitcherService(props.leanLawAuth, props.http);
      accountSwitcherService.switchFirm(company, redirect);
    }
    async function accept(account) {
      listsState.accepting = true;
      account.accepting = true;
      try {
        await axios({
          url: `/me/accounts/${account.id}/accept`,
          method: "POST"
        });
        fetchMe();
      } catch (error) {
        props.alerts.error(error.response.data.message);
      } finally {
        listsState.accepting = false;
        account.accepting = false;
      }
    }
    function connect(sandbox) {
      const {
        domain
      } = props.leanLawAuth;
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port ? `:${window.location.port}` : "";
      const redirect = props.state.href(props.state.current.name, {}).substring(2);
      const url = `${domain || protocol}//${hostname}${port}/Intuit/OAuth2?secondary=true&redirect=${redirect}${sandbox ? "&sandbox=true" : ""}`;
      window.intuit.ipp.anywhere.setup({
        grantUrl: url
      });
      window.intuit.ipp.anywhere.controller.onConnectToIntuitClicked(this);
    }
    function confirmAsync(message) {
      return new Promise(resolve => {
        bootbox.confirm(message, result => resolve(result));
      });
    }
    async function disconnect(account) {
      const confirmed = await confirmAsync(`This will disconnect you from the ${account.company.name} LeanLaw account`);
      if (!confirmed) return;
      account.disconnecting = true;
      try {
        await axios({
          url: `/me/accounts/${account.id}/remove`,
          method: "POST"
        });
        fetchMe();
      } catch (error) {
        props.alerts.error(error.response.data.message);
      } finally {
        account.disconnecting = false;
      }
    }
    function closeModal() {
      fetchMe();
      toggleCreateCompanyModal();
    }
    function toggleCreateCompanyModal() {
      listsState.showCreateCompanyModal = !listsState.showCreateCompanyModal;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: "My Firms"
      }), _cache[16] || (_cache[16] = _createElementVNode("p", null, "You are part of the following LeanLaw accounts", -1)), _unref(listsState).showCreateCompanyModal ? (_openBlock(), _createBlock(FirmCreate, {
        key: 0,
        alerts: __props.alerts,
        listsState: _unref(listsState),
        onCancel: _cache[0] || (_cache[0] = $event => toggleCreateCompanyModal()),
        onUpdate: _cache[1] || (_cache[1] = $event => closeModal())
      }, null, 8, ["alerts", "listsState"])) : _createCommentVNode("", true), _createElementVNode("table", _hoisted_2, [_cache[9] || (_cache[9] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Firm Name"), _createElementVNode("th", null, "Subscription"), _createElementVNode("th", null, "Seats"), _createElementVNode("th"), _createElementVNode("th")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listsState).me.accounts, a => {
        return _openBlock(), _createElementBlock("tr", {
          key: a.id
        }, [_createElementVNode("td", null, _toDisplayString(a.company.name), 1), _createElementVNode("td", null, [_withDirectives(_createElementVNode("span", null, [_cache[5] || (_cache[5] = _createTextVNode(" trial ", -1)), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(a.company.subscription.trialEndDays) + " days left)", 513), [[_vShow, a.company.subscription.trialEndDays]])], 512), [[_vShow, a.company.subscription.trial]]), _withDirectives(_createElementVNode("span", null, "subscribed", 512), [[_vShow, a.company.subscription.standard]]), _withDirectives(_createElementVNode("span", null, "inactive", 512), [[_vShow, a.company.subscription.inactive]]), _withDirectives(_createElementVNode("span", null, "free", 512), [[_vShow, a.company.subscription.accountant]])]), _createElementVNode("td", null, [_withDirectives(_createElementVNode("span", null, "-", 512), [[_vShow, a.company.subscription.accountant]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(a.company.subscription.seats), 513), [[_vShow, !a.company.subscription.accountant]])]), _createElementVNode("td", null, [_withDirectives(_createElementVNode("span", null, "Currently logged in here", 512), [[_vShow, a.id == _unref(listsState).me.id]]), _withDirectives(_createElementVNode("span", null, [_withDirectives(_createElementVNode("span", null, [_createVNode(LlSecondaryButton, {
          size: "small",
          "prepend-icon": "mdi-login",
          disabled: _unref(listsState).accepting,
          onClick: _withModifiers($event => login(a), ["prevent"])
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Login to this firm ", -1)]))]),
          _: 1
        }, 8, ["disabled", "onClick"])], 512), [[_vShow, a.registered]]), _withDirectives(_createElementVNode("span", null, [_createVNode(LlSecondaryButton, {
          color: "primary",
          size: "small",
          loading: a.accepting,
          disabled: _unref(listsState).accepting,
          onClick: _withModifiers($event => accept(a), ["prevent"])
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Accept Invite ", -1)]))]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])], 512), [[_vShow, !a.registered]])], 512), [[_vShow, a.id != _unref(listsState).me.id]])]), _createElementVNode("td", null, [_withDirectives(_createVNode(LlSecondaryButton, {
          size: "small",
          "prepend-icon": "mdi-close",
          onClick: _withModifiers($event => disconnect(a), ["prevent"])
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Disconnect Firm ", -1)]))]),
          _: 1
        }, 8, ["onClick"]), [[_vShow, !a.primary || !a.disconnecting]]), _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [[_vShow, a.disconnecting]])])]);
      }), 128))])]), _unref(listsState).me.company?.accountant ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(MainHeader, {
        content: "New Firm"
      }), _cache[13] || (_cache[13] = _createElementVNode("p", null, " This allows you to set up additional firms for your clients. The firms will be started with a two week trial after which they can start a subscription. ", -1)), _createElementVNode("p", null, [_createVNode(LlSecondaryButton, {
        color: "primary",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => toggleCreateCompanyModal(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Set up new firm ", -1)]))]),
        _: 1
      })]), _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)), _cache[15] || (_cache[15] = _createElementVNode("p", null, " Or add yourself to an existing LeanLaw account (if you already have access to that same account through QuickBooks) ", -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(LlSecondaryButton, {
        onClick: _cache[3] || (_cache[3] = $event => connect())
      }, {
        default: _withCtx(() => [_createVNode(QboIcon, {
          class: "mr-1"
        }), _cache[11] || (_cache[11] = _createTextVNode(" Connect with QuickBooks ", -1))]),
        _: 1
      })]), _createElementVNode("div", null, [_withDirectives(_createVNode(LlSecondaryButton, {
        onClick: _cache[4] || (_cache[4] = $event => connect(true))
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Connect with Sandbox ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(listsState).me.features?.sandbox]])])])])) : _createCommentVNode("", true)]);
    };
  }
};